import { CopyOutlined } from "@ant-design/icons";
import { useGetOfferQuery } from "api/TenantSlug/Offer/hooks";
import { OfferLinkDetailForm } from "components/Forms/OfferLinkDetailForm/OfferLinkDetailForm.tsx";
import { OfferDetail } from "components/other/OfferDetail/OfferDetail";
import { ActionTitle } from "components/UI/ActionTitle/ActionTitle.tsx";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useState } from "react";
import { toast } from "react-toastify";

export const OfferLinkDetail = ({ offerId }: { offerId: string }) => {
    const { data, isLoading, isError } = useGetOfferQuery(offerId, { filter: { include: "offerLinks" } });
    const offer = data?.offer;
    const { t } = usePaldockTranslation("components.offer-link-detail");
    const { t: tC } = usePaldockTranslation("common");

    const [currentUrl, setCurrentUrl] = useState<string>("");

    const copyEndpointToClipboard = () => {
        if (currentUrl) {
            navigator.clipboard
                .writeText(currentUrl)
                .then(() => toast.info(t("messages.link_copied")))
                .catch(() => toast.error(t("messages.copy_error")));
        }
    };

    if (!offer) {
        return <QueryState isLoading={isLoading} isError={isError || !isLoading} errorKey="errors.loading_offer" />;
    }
    return (
        <OfferDetail offer={offer}>
            <SectionContentWrapper>
                <ActionTitle
                    title={{
                        text: t("title"),
                        level: 3,
                    }}
                    buttons={
                        currentUrl
                            ? [
                                  {
                                      text: tC("copy"),
                                      icon: <CopyOutlined />,
                                      callback: copyEndpointToClipboard,
                                  },
                              ]
                            : []
                    }
                />
                <OfferLinkDetailForm
                    offerId={offer.id}
                    showDomainSelect={true}
                    showUserSelect={true}
                    onUrlChange={setCurrentUrl}
                />
            </SectionContentWrapper>
        </OfferDetail>
    );
};
